import { render, staticRenderFns } from "./VehicleGroupDetail.vue?vue&type=template&id=d27af8be&scoped=true&"
import script from "./VehicleGroupDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./VehicleGroupDetail.vue?vue&type=style&index=0&id=d27af8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27af8be",
  null
  
)

export default component.exports